export const getFinalCompensationStatusLabel = (row) => {
    if (!row) {
        return '';
    }

    const candidates = [
        row.compensationState?.title,
        row.compensationState?.status,
        row.finalCompensationState?.title,
        row.finalCompensationState?.status,
        row.state?.title,
        row.state?.status,
        row.compensationStateTitle,
        row.compensationStatus,
        row.finalCompensationStatus,
        row.statusTitle,
        row.currentStatus,
        row.compensationInformation?.status,
        row.compensationInformation?.statusTitle,
        row.compensationInformation?.state?.title,
        row.compensationInformation?.stateTitle,
        row.compensationInfo?.status,
        row.compensationInfo?.statusTitle,
        row.compensationInfo?.state?.title,
        row.compensationInfo?.stateTitle,
        typeof row.compensationState === 'string' ? row.compensationState : null,
        typeof row.finalCompensationState === 'string' ? row.finalCompensationState : null,
        typeof row.state === 'string' ? row.state : null,
        typeof row.status === 'string' ? row.status : null,
        row.status?.title
    ];

    const resolved = candidates.find((value) => typeof value === 'string' && value.trim().length > 0);
    return resolved ? resolved.trim() : '';
};

export const getFinalCompensationStatusOrder = (row) => {
    const rawOrder = row?.compensationState?.order
        ?? row?.finalCompensationState?.order
        ?? row?.compensationStateOrder
        ?? row?.finalCompensationStateOrder;

    const order = Number(rawOrder);
    return Number.isNaN(order) ? null : order;
};
